import React from 'react';
export function FicheTPPanel() {
  return <div className="bg-white shadow-2xl overflow-hidden flex flex-col" data-id="element-58" data-mp="36bzfoo46k3be">
      <div className="bg-primary-dark p-8 flex justify-between items-center shrink-0" data-id="element-59" data-mp="1lgbnj3ltqvms">
        <div data-id="element-60" data-mp="1z6yhkign3xcj">
          <p className="text-brand-orange font-bold text-sm tracking-wider mb-1" data-id="element-61" data-mp="1z7gpwdgku20t">
            FICHE FORMATION
          </p>
          <h2 className="text-3xl font-heading font-extrabold text-white" data-id="element-62" data-mp="1uengvde2s7ix">
            TP CONSEILLER DE VENTE
          </h2>
        </div>
        <div className="bg-brand-orange text-white font-bold px-6 py-2" data-id="element-63" data-mp="2461ne54g27lk">
          Niveau 4 • RNCP37098 • 2026–2027
        </div>
      </div>
      <div className="flex-1 flex p-8 gap-12" data-id="element-64" data-mp="2i49f9ymmiipv">
        <div className="w-[45%] flex flex-col" data-id="element-65" data-mp="2d6ga98x23ur6">
          <h3 className="text-2xl font-heading font-extrabold text-primary-dark mb-4 leading-tight" data-id="element-66" data-mp="2d7rdn7mlb0hr">
            FORMER UN VENDEUR CONSEIL OPÉRATIONNEL EN OMNICANAL
          </h3>
          <p className="text-primary-dark font-bold mb-6" data-id="element-67" data-mp="it8ad2u84syo">
            Le parcours prépare à conseiller des clients, animer l'offre
            commerciale, traiter les flux marchands et contribuer aux résultats
            d'une unité marchande.
          </p>

          <h4 className="text-brand-orange font-bold mb-2" data-id="element-68" data-mp="15jrytyshdik8">PUBLIC VISÉ</h4>
          <p className="text-primary-dark text-sm mb-6" data-id="element-69" data-mp="15igt3tfh60qh">
            Candidats souhaitant exercer dans la vente, le conseil client, la
            relation omnicanale, le commerce de proximité, la grande
            distribution ou les magasins spécialisés.
          </p>

          <h4 className="text-brand-orange font-bold mb-2" data-id="element-70" data-mp="1j9veu80rog18">PRÉREQUIS</h4>
          <p className="text-primary-dark text-sm mb-6" data-id="element-71" data-mp="1o9q8ukfu9lqi">
            Compréhension orale et écrite du français, bases de calcul
            commercial, aisance relationnelle, projet professionnel validé après
            entretien et positionnement.
          </p>

          <div className="bg-primary-dark text-white p-6 mt-auto" data-id="element-72" data-mp="3q3z7elmmfw57">
            <h4 className="text-brand-orange font-bold mb-2" data-id="element-73" data-mp="3v195sqrzni56">
              OBJECTIFS PÉDAGOGIQUES MESURABLES
            </h4>
            <p className="text-sm font-medium" data-id="element-74" data-mp="3n248rlrnn6x4">
              À l'issue du parcours, l'apprenant sera capable de réaliser une
              veille commerciale, traiter une réception et une opération
              promotionnelle, conduire un entretien de vente, gérer une
              réclamation, suivre ses ventes et proposer des actions
              d'amélioration à partir d'indicateurs.
            </p>
          </div>
        </div>
        <div className="w-[55%] flex flex-col gap-4 text-sm" data-id="element-75" data-mp="4uyaj858olnr">
          <div className="flex gap-8 border-b border-primary/20 pb-4" data-id="element-76" data-mp="4skfv0eh1bgq">
            <div className="w-1/2" data-id="element-77" data-mp="jirqity8lq6v">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-78" data-mp="ek80oigivu98">DURÉE</h4>
              <p className="text-primary-dark" data-id="element-79" data-mp="ekzvvs67jpyz">
                Parcours en alternance sur 1 an, session 2026–2027.
              </p>
            </div>
            <div className="w-1/2" data-id="element-80" data-mp="oixi6a4ibcoy">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-81" data-mp="ojyxwrwgwnd0">RYTHME</h4>
              <p className="text-primary-dark" data-id="element-82" data-mp="177raj8hduigx">
                4 jours en entreprise et 1 jour en centre de formation
                (mercredi)
              </p>
            </div>
          </div>
          <div className="flex gap-8 border-b border-primary/20 pb-4" data-id="element-83" data-mp="y6t6wrauwcyv">
            <div className="w-1/2" data-id="element-84" data-mp="134umh292pu5l">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-85" data-mp="1341keel27sts">RENTRÉE</h4>
              <p className="text-primary-dark" data-id="element-86" data-mp="ofoo1gi287yr">
                25 septembre 2026, sous réserve de places disponibles.
              </p>
            </div>
            <div className="w-1/2" data-id="element-87" data-mp="t8zz5ttwnawh">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-88" data-mp="ffs41s6m7xa1">ACCÈS</h4>
              <p className="text-primary-dark" data-id="element-89" data-mp="fdp68lz80zur">
                Candidature, entretien, positionnement, validation du projet et
                contrat d'apprentissage.
              </p>
            </div>
          </div>
          <div className="flex gap-8 border-b border-primary/20 pb-4" data-id="element-90" data-mp="ag5upttwr16i">
            <div className="w-1/2" data-id="element-91" data-mp="aii77rgwcjc6">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-92" data-mp="1cud54siuamoy">
                DÉLAI D'ACCÈS
              </h4>
              <p className="text-primary-dark" data-id="element-93" data-mp="18s0066bx2st8">
                Selon calendrier, date de candidature, places disponibles et
                contractualisation.
              </p>
            </div>
            <div className="w-1/2" data-id="element-94" data-mp="z38bc725komj">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-95" data-mp="z26pd7jlmhq1">
                TARIF APPRENTI
              </h4>
              <p className="text-primary-dark" data-id="element-96" data-mp="u198cyabrtq4">
                0 € pour l'apprenti sous contrat ; financement selon prise en
                charge OPCO.
              </p>
            </div>
          </div>
          <div className="border-b border-brand-orange pb-4" data-id="element-97" data-mp="l4ifeur2kuzr">
            <h4 className="font-bold text-primary-dark mb-1" data-id="element-98" data-mp="g4vzuenrr2ns">
              MÉTHODES MOBILISÉES
            </h4>
            <p className="text-primary-dark" data-id="element-99" data-mp="2ffx73h3n54i5">
              Apports ciblés, ateliers produits, cas de réception,
              merchandising, jeux de rôle vente/réclamation, tableau de bord,
              productions professionnelles et accompagnement individualisé.
            </p>
          </div>
          <div className="flex gap-8 border-b border-primary/20 pb-4" data-id="element-100" data-mp="2myd5tya2htjs">
            <div className="w-1/2" data-id="element-101" data-mp="2rrz8cxmioh1v">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-102" data-mp="2rt0xg60db42l">
                ÉVALUATIONS EN FORMATION
              </h4>
              <p className="text-primary-dark" data-id="element-103" data-mp="1z28umposrh6a">
                Quiz, mises en situation, études de cas, fiches produits,
                diaporama, entretiens simulés et dossier professionnel.
              </p>
            </div>
            <div className="w-1/2" data-id="element-104" data-mp="2906phw15wc7v">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-105" data-mp="28z5530y9addh">
                ÉPREUVE CERTIFICATIVE
              </h4>
              <p className="text-primary-dark" data-id="element-106" data-mp="2czp284itxgzm">
                Mise en situation 2 h, entretien technique 30 min, productions 1
                h 10, entretien final 15 min.
              </p>
            </div>
          </div>
          <div className="flex gap-8" data-id="element-107" data-mp="1pbxdhdtihp9j">
            <div className="w-1/2" data-id="element-108" data-mp="1pavos6jkp49c">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-109" data-mp="1kdcd9ee9f5l3">
                ACCESSIBILITÉ PSH
              </h4>
              <p className="text-primary-dark" data-id="element-110" data-mp="1ycvbnfh9r2k7">
                Étude individualisée des besoins. Référent handicap :
                samir@zilleniumalternance.fr.
              </p>
            </div>
            <div className="w-1/2" data-id="element-111" data-mp="15o6d9o7llbc5">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-112" data-mp="15p96w3wb1rvr">CONTACT</h4>
              <p className="text-primary-dark" data-id="element-113" data-mp="11nnlfu5pg59y">
                09 83 49 01 81 • contact@zilleniumalternance.fr
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-lavande p-6 text-center text-primary-dark shrink-0 font-bold" data-id="element-114" data-mp="1an0wgr9h91ws">
        <p data-id="element-115" data-mp="mxopzz5jb7y6">
          Certification visée : TP - Conseiller de vente, fiche RNCP37098
          enregistrée auprès de France Compétences.
        </p>
      </div>
    </div>;
}
export function FicheBTSPanel() {
  return <div className="bg-white shadow-2xl overflow-hidden flex flex-col" data-id="element-116" data-mp="2tlystbv8lzmn">
      <div className="bg-primary-dark p-8 flex justify-between items-center shrink-0" data-id="element-117" data-mp="2ycxcmlffpfun">
        <div data-id="element-118" data-mp="2yes0a7i3bm2f">
          <p className="text-brand-orange font-bold text-sm tracking-wider mb-1" data-id="element-119" data-mp="2klsjm26knlta">
            FICHE FORMATION
          </p>
          <h2 className="text-3xl font-heading font-extrabold text-white" data-id="element-120" data-mp="2pju4msnk5v7e">
            BTS NDRC
          </h2>
        </div>
        <div className="bg-brand-orange text-white font-bold px-6 py-2" data-id="element-121" data-mp="3dapq781f7u67">
          Niveau 5 • RNCP38368 • 2026–2028
        </div>
      </div>
      <div className="flex-1 flex p-8 gap-12" data-id="element-122" data-mp="33c0jmbez5w59">
        <div className="w-[45%] flex flex-col" data-id="element-123" data-mp="33b8kwrq2ziar">
          <h3 className="text-2xl font-heading font-extrabold text-primary-dark mb-4 leading-tight" data-id="element-124" data-mp="38b4r8xm93lth">
            DÉVELOPPER LA RELATION CLIENT ET LA PERFORMANCE COMMERCIALE
          </h3>
          <p className="text-primary-dark font-bold mb-6" data-id="element-125" data-mp="1rz7t13xx7dqs">
            Le BTS Négociation et digitalisation de la relation client forme des
            commerciaux généralistes capables d'agir en présentiel, à distance,
            en e-relation et au sein de réseaux.
          </p>

          <h4 className="text-brand-orange font-bold mb-2" data-id="element-126" data-mp="2jj4vdenynk2n">PUBLIC VISÉ</h4>
          <p className="text-primary-dark text-sm mb-6" data-id="element-127" data-mp="2em4ncy7jw78w">
            Candidats souhaitant exercer dans la prospection, la négociation, la
            gestion de clientèle, la vente à distance, l'e-commerce ou
            l'animation commerciale.
          </p>

          <h4 className="text-brand-orange font-bold mb-2" data-id="element-128" data-mp="32b7h34fglqjr">PRÉREQUIS</h4>
          <p className="text-primary-dark text-sm mb-6" data-id="element-129" data-mp="32d0l0byotwo2">
            Niveau 4 validé ou parcours compatible, expression écrite et orale
            solide, bases numériques, motivation commerciale et projet validé
            après positionnement.
          </p>

          <div className="bg-primary-dark text-white p-6 mt-auto" data-id="element-130" data-mp="3q1a5nak60edm">
            <h4 className="text-brand-orange font-bold mb-2" data-id="element-131" data-mp="3l99yoy5ogl7j">
              OBJECTIFS PÉDAGOGIQUES MESURABLES
            </h4>
            <p className="text-sm font-medium" data-id="element-132" data-mp="3tjhac7fzj8tb">
              À l'issue du parcours, l'apprenant sera capable de cibler et
              prospecter une clientèle, négocier une solution, organiser une
              action commerciale, exploiter l'information client, animer la
              relation digitale, développer l'e-commerce et contribuer à un
              réseau de distributeurs, partenaires ou vente directe.
            </p>
          </div>
        </div>
        <div className="w-[55%] flex flex-col gap-4 text-sm" data-id="element-133" data-mp="kd9c810w0ax9">
          <div className="flex gap-8 border-b border-primary/20 pb-4" data-id="element-134" data-mp="kboclwzpu1sj">
            <div className="w-1/2" data-id="element-135" data-mp="p5iwp1j8gis5">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-136" data-mp="p6k7r609159v">DURÉE</h4>
              <p className="text-primary-dark" data-id="element-137" data-mp="u2svh7sii6sn">
                Parcours en alternance sur 2 ans, session 2026–2028.
              </p>
            </div>
            <div className="w-1/2" data-id="element-138" data-mp="1418k9442h3yz">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-139" data-mp="1429zzlw12en1">RYTHME</h4>
              <p className="text-primary-dark" data-id="element-140" data-mp="2f29j3xf3w8g3">
                3 jours en entreprise et 2 jour en centre de formation. (Lundi,
                Mardi)
              </p>
            </div>
          </div>
          <div className="flex gap-8 border-b border-primary/20 pb-4" data-id="element-141" data-mp="2o1wlalfntia7">
            <div className="w-1/2" data-id="element-142" data-mp="2ssv5hw3rr0iq">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-143" data-mp="2stwrgvmbp7f8">RENTRÉE</h4>
              <p className="text-primary-dark" data-id="element-144" data-mp="2xs7yyzp5b5ua">
                25 septembre 2026, sous réserve de places disponibles.
              </p>
            </div>
            <div className="w-1/2" data-id="element-145" data-mp="32p7y0qnkv8bw">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-146" data-mp="36sw5l9c7m3x5">ACCÈS</h4>
              <p className="text-primary-dark" data-id="element-147" data-mp="36qjn8v2jhrjk">
                Candidature, entretien, positionnement, validation du projet et
                contrat d'apprentissage.
              </p>
            </div>
          </div>
          <div className="flex gap-8 border-b border-primary/20 pb-4" data-id="element-148" data-mp="1hdq2eqzq6zyl">
            <div className="w-1/2" data-id="element-149" data-mp="1hdyb06otfj3z">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-150" data-mp="19tx9xdpu26tx">
                DÉLAI D'ACCÈS
              </h4>
              <p className="text-primary-dark" data-id="element-151" data-mp="153727ttxprw2">
                Selon calendrier, date de candidature, places disponibles et
                contractualisation.
              </p>
            </div>
            <div className="w-1/2" data-id="element-152" data-mp="v5svilxtchgy">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-153" data-mp="v6vp51misy0k">
                TARIF APPRENTI
              </h4>
              <p className="text-primary-dark" data-id="element-154" data-mp="1sqyq7uou7td6">
                0 € pour l'apprenti sous contrat ; financement selon prise en
                charge OPCO.
              </p>
            </div>
          </div>
          <div className="border-b border-brand-orange pb-4" data-id="element-155" data-mp="1iwycj4fhpfsu">
            <h4 className="font-bold text-primary-dark mb-1" data-id="element-156" data-mp="1esi877liygfq">
              MÉTHODES MOBILISÉES
            </h4>
            <p className="text-primary-dark" data-id="element-157" data-mp="7h9oe9qi2aqg">
              Apports structurés, études de cas, entraînements de négociation,
              CRM et outils digitaux, projects commerciaux, e-commerce, jeux de
              rôle et suivi individualisé.
            </p>
          </div>
          <div className="flex gap-8 border-b border-primary/20 pb-4" data-id="element-158" data-mp="9tby1b0fq5ey">
            <div className="w-1/2" data-id="element-159" data-mp="3r2qpey3t8e05">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-160" data-mp="3r1p5030wmf5r">
                ÉVALUATIONS EN FORMATION
              </h4>
              <p className="text-primary-dark" data-id="element-161" data-mp="3w3o8re0k3e38">
                Contrôles, dossiers, oraux, situations professionnelles,
                productions digitales et bilans d'acquisition.
              </p>
            </div>
            <div className="w-1/2" data-id="element-162" data-mp="38c0p9h5mj5az">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-163" data-mp="38csbw2h8tsp4">
                CERTIFICATION
              </h4>
              <p className="text-primary-dark" data-id="element-164" data-mp="3dbvfdihkrquz">
                Épreuves selon règlement du BTS : CCF lorsque l'habilitation le
                permet ou forme ponctuelle.
              </p>
            </div>
          </div>
          <div className="flex gap-8" data-id="element-165" data-mp="33c4hr7xpwvqo">
            <div className="w-1/2" data-id="element-166" data-mp="2koc54rcsz0mr">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-167" data-mp="2kpeyr71ifh6d">
                ACCESSIBILITÉ PSH
              </h4>
              <p className="text-primary-dark" data-id="element-168" data-mp="2frdewjw9fdtu">
                Étude individualisée des besoins. Référent handicap :
                samir@zilleniumalternance.fr.
              </p>
            </div>
            <div className="w-1/2" data-id="element-169" data-mp="2oow29uxdm48w">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-170" data-mp="33n80w74b7n2p">CONTACT</h4>
              <p className="text-primary-dark" data-id="element-171" data-mp="33ldcujxqreue">
                09 83 49 01 81 • contact@zilleniumalternance.fr
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-lavande p-6 text-center text-primary-dark shrink-0 font-bold" data-id="element-172" data-mp="3cf05402qpzyu">
        <p data-id="element-173" data-mp="38eq0aqqopflk">
          Certification visée : BTS - Négociation et digitalisation de la
          relation client, fiche RNCP38368.
        </p>
      </div>
    </div>;
}
export function CertifBTSPanel() {
  return <div className="bg-lavande shadow-2xl overflow-hidden flex flex-col" data-id="element-174" data-mp="3hgpgjgtvkfng">
      <div className="bg-primary-dark p-8 flex justify-between items-center shrink-0" data-id="element-175" data-mp="5atnmcqsmy5m">
        <div data-id="element-176" data-mp="9c54ntvlqb27">
          <p className="text-brand-orange font-bold text-sm tracking-wider mb-1" data-id="element-177" data-mp="9bnad2si26wx">
            CERTIFICATION PROFESSIONNELLE
          </p>
          <h2 className="text-3xl font-heading font-extrabold text-white" data-id="element-178" data-mp="e69dyjscav6g">
            BTS NDRC
          </h2>
        </div>
        <div className="bg-brand-orange text-white font-bold px-6 py-2" data-id="element-179" data-mp="3iimvvwr1jw86">
          RNCP38368 • France Compétences
        </div>
      </div>
      <div className="flex-1 flex p-8 gap-12 bg-white m-8 mt-0 shadow-sm" data-id="element-180" data-mp="3mk8gk49thesx">
        <div className="w-[35%] flex flex-col" data-id="element-181" data-mp="3rhrvl6ec9vlx">
          <h3 className="text-2xl font-heading font-extrabold text-primary-dark mb-6 bg-lavande p-2" data-id="element-182" data-mp="3rl5ycfqx06tw">
            REPÈRES RNCP
          </h3>
          <div className="flex flex-col gap-3 text-sm mb-6" data-id="element-183" data-mp="16tdjcpvchbir">
            <div className="border-b border-primary/20 pb-2" data-id="element-184" data-mp="16uyd4d9u4qfk">
              <h4 className="font-bold text-primary-dark" data-id="element-185" data-mp="1bq3zfd75g746">INTITULÉ EXACT</h4>
              <p className="text-primary-dark" data-id="element-186" data-mp="2w9zgn5e63y8h">
                BTS - Négociation et digitalisation de la relation client.
              </p>
            </div>
            <div className="border-b border-primary/20 pb-2" data-id="element-187" data-mp="2rcz9ss9hurgb">
              <h4 className="font-bold text-primary-dark" data-id="element-188" data-mp="2mibr5a168r9n">NIVEAU / DOMAINE</h4>
              <p className="text-primary-dark" data-id="element-189" data-mp="2hjs579mkvfha">
                Niveau 5 • NSF 312 Commerce, vente • Relation client et force de
                vente.
              </p>
            </div>
            <div className="border-b border-primary/20 pb-2" data-id="element-190" data-mp="28jvmdomvdau5">
              <h4 className="font-bold text-primary-dark" data-id="element-191" data-mp="28mhrlhmafe97">CERTIFICATEUR</h4>
              <p className="text-primary-dark" data-id="element-192" data-mp="23laldmzsmn4n">
                Ministère de l'Enseignement Supérieur et de la Recherche.
              </p>
            </div>
            <div className="border-b border-primary/20 pb-2" data-id="element-193" data-mp="1u75ojb1qid8">
              <h4 className="font-bold text-primary-dark" data-id="element-194" data-mp="1rbc1768eful">ENREGISTREMENT</h4>
              <p className="text-primary-dark" data-id="element-195" data-mp="3t0rurxhjjg7m">
                Début des parcours : 01/01/2024 • Échéance : 31/12/2028.
              </p>
            </div>
            <div className="border-b border-primary/20 pb-2" data-id="element-196" data-mp="1w2183io624ab">
              <h4 className="font-bold text-primary-dark" data-id="element-197" data-mp="1w3cfdsgtlu66">
                DERNIÈRE DÉLIVRANCE
              </h4>
              <p className="text-primary-dark" data-id="element-198" data-mp="1mbpwrb25kste">
                Dernière délivrance possible mentionnée : 31/12/2031.
              </p>
            </div>
            <div data-id="element-199" data-mp="2a1tyfcvs6ihr">
              <h4 className="font-bold text-primary-dark" data-id="element-200" data-mp="29z7rnfgps70l">LIEN OFFICIEL</h4>
              <p className="text-primary-dark" data-id="element-201" data-mp="2ez2f191a6egw">
                francecompetences.fr/recherche/rncp/38368/
              </p>
            </div>
          </div>
          <div className="bg-primary-dark text-white p-4 mb-4" data-id="element-202" data-mp="251xu1cj68p1o">
            <div className="text-2xl font-extrabold text-brand-orange mb-1" data-id="element-203" data-mp="254alqheqedrx">
              2027
            </div>
            <div className="font-medium text-sm" data-id="element-204" data-mp="pntmenxb6tqm">
              Session BTS 2025–2027 : examen prévu en 2027, résultat non
              disponible.
            </div>
          </div>
          <div className="bg-brand-orange text-white p-4" data-id="element-205" data-mp="m5mfdke0nn7r">
            <div className="text-2xl font-extrabold mb-1" data-id="element-206" data-mp="h3ex6d2lfawz">2028</div>
            <div className="font-medium text-sm" data-id="element-207" data-mp="w1foetsj0yks">
              Session BTS 2026–2028 : examen prévu en 2028, indicateur publié
              après jury.
            </div>
          </div>
        </div>
        <div className="w-[65%] flex flex-col gap-4 text-sm pt-2" data-id="element-208" data-mp="3csajja3xbh9">
          <h3 className="text-2xl font-heading font-extrabold text-primary-dark mb-2" data-id="element-209" data-mp="3axnnzf9z9aj">
            BLOCS, ÉPREUVES ET MÉTIERS
          </h3>
          <div className="flex gap-8 border-b border-primary/20 pb-4" data-id="element-210" data-mp="d3d6eyyec1wh">
            <div className="w-1/2" data-id="element-211" data-mp="d4oaz0zo1don">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-212" data-mp="8bv3448whp8c">
                RNCP38368BC01
              </h4>
              <p className="text-primary-dark" data-id="element-213" data-mp="3gqwqdex3xf2a">
                Relation client et négociation-vente : prospection, négociation,
                événement commercial, information commerciale.
              </p>
            </div>
            <div className="w-1/2" data-id="element-214" data-mp="2qbd3mt6bgcgw">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-215" data-mp="2v8dbn9mq7pan">
                RNCP38368BC02
              </h4>
              <p className="text-primary-dark" data-id="element-216" data-mp="3076qp6hnvocx">
                Relation client à distance et digitalisation : omnicanal,
                relation digitale, e-commerce.
              </p>
            </div>
          </div>
          <div className="flex gap-8 border-b border-primary/20 pb-4" data-id="element-217" data-mp="397d3eq5jckb1">
            <div className="w-1/2" data-id="element-218" data-mp="3e6y00tx8ggkl">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-219" data-mp="3e66cm6dshp5e">
                RNCP38368BC03
              </h4>
              <p className="text-primary-dark" data-id="element-220" data-mp="3iyzjp0wqd9kn">
                Relation client et animation de réseaux : distributeurs,
                partenaires, vente directe.
              </p>
            </div>
            <div className="w-1/2" data-id="element-221" data-mp="3s0pbi7uiyaiy">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-222" data-mp="sbgxhp5kyi5">ÉVALUATIONS</h4>
              <p className="text-primary-dark" data-id="element-223" data-mp="q8gs4uadozp">
                BC01 et BC03 : CCF 2 situations si habilité ou ponctuelle orale
                ; BC02 : écrite et pratique.
              </p>
            </div>
          </div>
          <div className="flex gap-8 border-b border-brand-orange pb-4" data-id="element-224" data-mp="1c9nreep9lsux">
            <div className="w-1/2" data-id="element-225" data-mp="1cbs6lssm6eai">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-226" data-mp="17bdzqe2r1ae2">
                CAPITALISATION
              </h4>
              <p className="text-primary-dark" data-id="element-227" data-mp="2401zfualkayo">
                Chaque unité correspond à un bloc ; dispense possible des
                épreuves déjà validées selon règlement du diplôme.
              </p>
            </div>
            <div className="w-1/2" data-id="element-228" data-mp="1v78fhjk7gneh">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-229" data-mp="1q9q65s2a065y">SECTEURS</h4>
              <p className="text-primary-dark" data-id="element-230" data-mp="1q7m6jmbettbh">
                Toute organisation commerciale, industrielle, artisanale,
                associative ou publique avec démarche commerciale.
              </p>
            </div>
          </div>
          <div data-id="element-231" data-mp="30m5kxdbtsa46">
            <h4 className="font-bold text-primary-dark mb-1" data-id="element-232" data-mp="30mnpcx8n5un6">
              DÉBOUCHÉS OFFICIELS
            </h4>
            <p className="text-primary-dark" data-id="element-233" data-mp="2vlqaatixhgpw">
              Commercial terrain, négociateur, conseiller commercial, chargé de
              clientèle, technico-commercial, téléconseiller, commercial
              e-commerce, chef de secteur, animateur réseau. Codes ROME : D1401,
              D1406, D1501, M1703, M1704.
            </p>
          </div>
        </div>
      </div>
      <div className="bg-lavande/50 p-6 text-center text-primary-dark shrink-0 font-bold" data-id="element-234" data-mp="3ecr4l493so34">
        <p data-id="element-235" data-mp="39lsl5vstj9vn">
          Les informations de certification sont issues de la fiche France
          Compétences RNCP38368 consultable publiquement.
        </p>
      </div>
    </div>;
}
export function CertifTPPanel() {
  return <div className="bg-lavande shadow-2xl overflow-hidden flex flex-col" data-id="element-236" data-mp="5xzbzugvztl7">
      <div className="bg-primary-dark p-8 flex justify-between items-center shrink-0" data-id="element-237" data-mp="168xrdetwloi">
        <div data-id="element-238" data-mp="9fn29km9mhrm">
          <p className="text-brand-orange font-bold text-sm tracking-wider mb-1" data-id="element-239" data-mp="9fww5jafl92l">
            CERTIFICATION PROFESSIONNELLE
          </p>
          <h2 className="text-3xl font-heading font-extrabold text-white" data-id="element-240" data-mp="dh083upcykyj">
            TP CONSEILLER DE VENTE
          </h2>
        </div>
        <div className="bg-brand-orange text-white font-bold px-6 py-2" data-id="element-241" data-mp="nemsgwpff4pw">
          RNCP37098 • France Compétences
        </div>
      </div>
      <div className="flex-1 flex p-8 gap-12 bg-white m-8 mt-0 shadow-sm" data-id="element-242" data-mp="sd7tuzgezufx">
        <div className="w-[35%] flex flex-col" data-id="element-243" data-mp="wet0w469pei7">
          <h3 className="text-2xl font-heading font-extrabold text-primary-dark mb-6 bg-lavande p-2" data-id="element-244" data-mp="wdhwq38wu4qk">
            REPÈRES RNCP
          </h3>
          <div className="flex flex-col gap-3 text-sm mb-6" data-id="element-245" data-mp="165xdix8h0n9v">
            <div className="border-b border-primary/20 pb-2" data-id="element-246" data-mp="167i7akmyo26o">
              <h4 className="font-bold text-primary-dark" data-id="element-247" data-mp="1b5s5l43zfiwi">INTITULÉ EXACT</h4>
              <p className="text-primary-dark" data-id="element-248" data-mp="1g320gza54mrq">TP - Conseiller de vente.</p>
            </div>
            <div className="border-b border-primary/20 pb-2" data-id="element-249" data-mp="qewna8fh5ih4">
              <h4 className="font-bold text-primary-dark" data-id="element-250" data-mp="qdbvgqkjodmy">NIVEAU / DOMAINE</h4>
              <p className="text-primary-dark" data-id="element-251" data-mp="lhwj6326qpsn">
                Niveau 4 • NSF 312m Commerce, vente • Formacode 34502.
              </p>
            </div>
            <div className="border-b border-primary/20 pb-2" data-id="element-252" data-mp="vdzjd3dh8ecy">
              <h4 className="font-bold text-primary-dark" data-id="element-253" data-mp="vcg2bajzxza4">CERTIFICATEUR</h4>
              <p className="text-primary-dark" data-id="element-254" data-mp="194coyz2wbgz4">
                Ministère du Travail du Plein Emploi et de l'Insertion.
              </p>
            </div>
            <div className="border-b border-primary/20 pb-2" data-id="element-255" data-mp="1j3txrpdg2azb">
              <h4 className="font-bold text-primary-dark" data-id="element-256" data-mp="1j20wyqpiikz8">ENREGISTREMENT</h4>
              <p className="text-primary-dark" data-id="element-257" data-mp="1e5jyp3olmq8f">
                Début des parcours : 25/01/2023 • Échéance : 25/01/2028.
              </p>
            </div>
            <div data-id="element-258" data-mp="3fwnd841m0oy9">
              <h4 className="font-bold text-primary-dark" data-id="element-259" data-mp="3fx5c78fnph9v">LIEN OFFICIEL</h4>
              <p className="text-primary-dark" data-id="element-260" data-mp="1vel6k28bs278">
                francecompetences.fr/recherche/rncp/37098/
              </p>
            </div>
          </div>
          <div className="bg-brand-orange text-white p-4 mb-4" data-id="element-261" data-mp="20cmnagia3pfj">
            <div className="text-3xl font-extrabold mb-1" data-id="element-262" data-mp="1lpb9s92jdvcs">100 %</div>
            <div className="font-bold text-sm" data-id="element-263" data-mp="1qnmjmjsu05v0">
              Taux de réussite constaté pour la session TP 2024–2025.
            </div>
          </div>
          <div className="bg-primary-dark text-white p-4" data-id="element-264" data-mp="1cma76icvqmdv">
            <div className="text-2xl font-extrabold mb-1" data-id="element-265" data-mp="1gpyfx4d8zo0p">À venir</div>
            <div className="font-medium text-sm" data-id="element-266" data-mp="1gn3w9f22678c">
              Session TP 2026–2027 : examen non encore passé, indicateur publié
              après jury.
            </div>
          </div>
        </div>
        <div className="w-[65%] flex flex-col gap-4 text-sm pt-2" data-id="element-267" data-mp="17qle8xvd83qj">
          <h3 className="text-2xl font-heading font-extrabold text-primary-dark mb-2" data-id="element-268" data-mp="2x4833v5r76py">
            BLOCS, ÉPREUVES ET MÉTIERS
          </h3>
          <div className="flex gap-8 border-b border-primary/20 pb-4" data-id="element-269" data-mp="120jxmj53sa19">
            <div className="w-1/2" data-id="element-270" data-mp="11yfsjxvgx4ze">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-271" data-mp="x1p4an9if32w">
                RNCP37098BC01
              </h4>
              <p className="text-primary-dark" data-id="element-272" data-mp="sz2ip43fmee5">
                Efficacité commerciale omnicanale : veille, flux marchands,
                merchandising, analyse des performances et compte rendu.
              </p>
            </div>
            <div className="w-1/2" data-id="element-273" data-mp="j38v8po6d0hl">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-274" data-mp="eaxy1uktjssq">
                RNCP37098BC02
              </h4>
              <p className="text-primary-dark" data-id="element-275" data-mp="9bl7ozuqo3le">
                Expérience client omnicanale : image de l'unité, entretien de
                vente, suivi des ventes, fidélisation.
              </p>
            </div>
          </div>
          <div className="flex gap-8 border-b border-primary/20 pb-4" data-id="element-276" data-mp="9v7p5msjwc0">
            <div className="w-1/2" data-id="element-277" data-mp="3rgy020ed88nt">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-278" data-mp="3rhznl4ckinmf">
                ÉPREUVE GLOBALE
              </h4>
              <p className="text-primary-dark" data-id="element-279" data-mp="26z71jw9wnl3u">
                3 h 55 : mise en situation 2 h, entretien technique 30 min,
                productions 1 h 10, entretien final 15 min.
              </p>
            </div>
            <div className="w-1/2" data-id="element-280" data-mp="2gvs7cjtr108q">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-281" data-mp="2kzhtl2myb5ql">
                CAPITALISATION
              </h4>
              <p className="text-primary-dark" data-id="element-282" data-mp="1oa8qnmqdn8md">
                Deux certificats de compétences professionnelles capitalisables
                selon les règles du titre professionnel.
              </p>
            </div>
          </div>
          <div className="flex gap-8 border-b border-brand-orange pb-4" data-id="element-283" data-mp="1x7j2pab0r1sc">
            <div className="w-1/2" data-id="element-284" data-mp="221x17lkz9p18">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-285" data-mp="2226qf6y77s5v">
                CORRESPONDANCE
              </h4>
              <p className="text-primary-dark" data-id="element-286" data-mp="19jt5u91vi2oq">
                Correspondance partielle avec l'ancien RNCP13620 TP
                Vendeur(se)-conseil en magasin.
              </p>
            </div>
            <div className="w-1/2" data-id="element-287" data-mp="27w5drzx514rt">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-288" data-mp="27v2otxjdlcej">SECTEURS</h4>
              <p className="text-primary-dark" data-id="element-289" data-mp="2mla11vishz6s">
                GMS, surfaces spécialisées, grands magasins, boutiques,
                proximité, négoces interentreprises, gros.
              </p>
            </div>
          </div>
          <div data-id="element-290" data-mp="1tww2nensh0up">
            <h4 className="font-bold text-primary-dark mb-1" data-id="element-291" data-mp="1twcs4j0gxeqp">
              DÉBOUCHÉS OFFICIELS
            </h4>
            <p className="text-primary-dark" data-id="element-292" data-mp="1ozclo6zpi9z2">
              Conseiller clientèle, vendeur expert, vendeur conseil, vendeur
              technique, vendeur en magasin, magasinier vendeur. Codes ROME :
              D1209, D1214, D1211, D1212, D1210.
            </p>
          </div>
        </div>
      </div>
      <div className="bg-lavande/50 p-6 text-center text-primary-dark shrink-0 font-bold" data-id="element-293" data-mp="3edslkhg36omf">
        <p data-id="element-294" data-mp="3acp4xsq7sok5">
          Les informations de certification sont issues de la fiche France
          Compétences RNCP37098 consultable publiquement.
        </p>
      </div>
    </div>;
}
export function ModalitesAccessPanel() {
  return <div className="bg-lavande shadow-2xl overflow-hidden flex flex-col" data-id="element-295" data-mp="37w7gpbev5s4w">
      <div className="bg-primary-dark p-8 flex justify-between items-center shrink-0" data-id="element-296" data-mp="3cusl7n15exz5">
        <div data-id="element-297" data-mp="3cwltf6retq99">
          <p className="text-brand-orange font-bold text-sm tracking-wider mb-1" data-id="element-298" data-mp="4ez1kzbit6dv">
            MODALITÉS D'ACCÈS — INFORMATIONS CANDIDATS
          </p>
          <h2 className="text-3xl font-heading font-extrabold text-white leading-tight" data-id="element-299" data-mp="9cqxs5j77env">
            ADMISSION, ACCOMPAGNEMENT ET ACCESSIBILITÉ
          </h2>
        </div>
        <div className="bg-brand-orange text-white font-bold px-6 py-2 max-w-[180px]" data-id="element-300" data-mp="3vsv3zk33ryoi">
          TP Conseiller de Vente • BTS NDRC
        </div>
      </div>
      <div className="flex-1 flex p-8 gap-12" data-id="element-301" data-mp="nbqmfd6pntk1">
        <div className="w-1/2 flex flex-col" data-id="element-302" data-mp="s4tibryynf3e">
          <h3 className="text-2xl font-heading font-extrabold text-primary-dark mb-4" data-id="element-303" data-mp="s6mol65nvxav">
            PARCOURS D'ACCÈS CANDIDAT
          </h3>
          <p className="text-primary-dark font-bold mb-6" data-id="element-304" data-mp="2jgg3q556x4ll">
            L'entrée en formation suit un processus transparent permettant de
            vérifier le projet, les prérequis, les besoins d'accompagnement et
            la faisabilité de l'alternance.
          </p>
          <div className="grid grid-cols-2 gap-x-6 gap-y-5 text-sm" data-id="element-305" data-mp="376k6kaak10bj">
            {[{
            n: '1',
            t: 'PREMIER CONTACT',
            d: 'Demande d\u2019information par téléphone, mail, formulaire, rendez-vous ou candidature directe.'
          }, {
            n: '2',
            t: 'DOSSIER CANDIDAT',
            d: 'Collecte des éléments nécessaires : identité, parcours, projet, niveau et formation visée.'
          }, {
            n: '3',
            t: 'ENTRETIEN',
            d: 'Analyse de la motivation, cohérence du projet, disponibilité et compréhension du rythme.'
          }, {
            n: '4',
            t: 'POSITIONNEMENT',
            d: 'Vérification des acquis, prérequis, besoins pédagogiques et éventuelles adaptations PSH.'
          }, {
            n: '5',
            t: 'INFORMATION COMPLÈTE',
            d: 'Remise ou présentation du programme, tarif, rythme, évaluation, accessibilité et contacts.'
          }, {
            n: '6',
            t: 'CONTRAT D\u2019ALTERNANCE',
            d: 'Accompagnement jusqu\u2019à la recherche d\u2019entreprise et la signature du contrat d\u2019apprentissage.'
          }].map(step => <div key={step.n} className="border-t-2 border-primary pt-3 flex gap-3" data-id="element-306" data-mp="2593co64i2tnv">
                <div className="w-8 h-8 bg-brand-orange text-white font-heading font-bold flex items-center justify-center shrink-0" data-id="element-307" data-mp="awmz0k9dkd8z">
                  {step.n}
                </div>
                <div data-id="element-308" data-mp="2m3h6drzob66n">
                  <h4 className="font-bold text-primary-dark mb-1" data-id="element-309" data-mp="2m3zd5ijyp2st">{step.t}</h4>
                  <p className="text-primary-dark" data-id="element-310" data-mp="28cuhssnmmwoa">{step.d}</p>
                </div>
              </div>)}
          </div>
        </div>
        <div className="w-1/2 flex flex-col" data-id="element-311" data-mp="2dbx9lbelj6eb">
          <h3 className="text-2xl font-heading font-extrabold text-primary-dark mb-4" data-id="element-312" data-mp="3119jyelntki7">
            DÉLAIS, SUIVI ET CONTACTS
          </h3>
          <div className="flex flex-col gap-4 text-sm" data-id="element-313" data-mp="351aa2wi4fk53">
            <div className="border-t-2 border-brand-orange pt-3" data-id="element-314" data-mp="2r32f2u4naswk">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-315" data-mp="2r4wqnhu118nz">
                DÉLAIS D'ACCÈS
              </h4>
              <p className="text-primary-dark" data-id="element-316" data-mp="2w3q63fsvj9qs">
                Entrée selon calendrier de rentrée, places disponibles, date de
                candidature, validation du dossier et signature du contrat
                d'apprentissage. Rentrée prévue : 25 septembre 2026.
              </p>
            </div>
            <div className="border-t border-primary/30 pt-3" data-id="element-317" data-mp="1844hk675fp54">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-318" data-mp="183mh0xdgeore">
                ACCOMPAGNEMENT ALTERNANCE
              </h4>
              <p className="text-primary-dark" data-id="element-319" data-mp="1m1jb9n4fqj2w">
                Aide à la préparation du CV, à l'entretien, à la recherche
                d'entreprise et à la mise en relation avec des structures
                d'accueil lorsque cela est possible.
              </p>
            </div>
            <div className="border-t border-primary/30 pt-3" data-id="element-320" data-mp="pbjsz0yhg674">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-321" data-mp="1362z9nhjrtup">
                ACCESSIBILITÉ HANDICAP
              </h4>
              <p className="text-primary-dark" data-id="element-322" data-mp="ycrtlpoh1j4d">
                Accueil des personnes en situation de handicap après étude
                individualisée des besoins, identification des compensations
                possibles et adaptation du parcours si nécessaire.
              </p>
            </div>
            <div className="bg-primary-dark text-white p-4 space-y-1" data-id="element-323" data-mp="25rn0exh47tur">
              <p data-id="element-324" data-mp="2apyan9bbo6di">
                <span className="text-brand-orange font-bold" data-id="element-325" data-mp="2apf2gkbh4wco">
                  Référent handicap :
                </span>{' '}
                samir@zilleniumalternance.fr
              </p>
              <p data-id="element-326" data-mp="2kfhvulmiccbj">
                <span className="text-brand-orange font-bold" data-id="element-327" data-mp="2kfzxxyvupkrd">
                  Contact formation :
                </span>{' '}
                contact@zilleniumalternance.fr
              </p>
              <p data-id="element-328" data-mp="1rsnkqfbkypaq">
                <span className="text-brand-orange font-bold" data-id="element-329" data-mp="1ru89fob7re0o">Téléphone :</span>{' '}
                09 83 49 01 81
              </p>
            </div>
            <div className="border-t border-primary/30 pt-3" data-id="element-330" data-mp="20tv9o6s7ids5">
              <h4 className="font-bold text-primary-dark mb-1" data-id="element-331" data-mp="386dsbw1wrvp4">ADRESSE</h4>
              <p className="text-primary-dark" data-id="element-332" data-mp="388ghkdv8lkss">
                Zillenium Alternance — 25 rue Gabriel Cortel, 89300 Joigny. Les
                informations publiées concernent uniquement le TP Conseiller de
                Vente et le BTS NDRC.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-lavande/50 p-6 text-center text-primary-dark shrink-0 font-bold" data-id="element-333" data-mp="rsbsligmvyt0">
        <p data-id="element-334" data-mp="rpz2uj4mwk5e">
          Aucune inscription définitive sans information complète du candidat,
          validation du projet, vérification des prérequis et contractualisation
          de l'alternance.
        </p>
      </div>
    </div>;
}